class Category {
    id: string = "";
    parentId: string = "";
    ownerId: string = "";
    level: number = 0;
    name: string = "";
}

export { Category};